export function convertDecimalPoundsToPoundsAndOunces(
  weightInDecimalPounds: number
) {
  const wholePart = Math.floor(weightInDecimalPounds);
  const fractionalPart = weightInDecimalPounds - wholePart;

  return { pounds: wholePart, ounces: Math.round(fractionalPart * 16) };
}
